__turbopack_context__.v({
  "illustration": "EmptyState-module-scss-module__e3_hhW__illustration",
  "inner": "EmptyState-module-scss-module__e3_hhW__inner",
  "root": "EmptyState-module-scss-module__e3_hhW__root",
  "subtitle": "EmptyState-module-scss-module__e3_hhW__subtitle",
  "title": "EmptyState-module-scss-module__e3_hhW__title",
});
